import { Grid, Typography } from '@mui/material'
import styled from '@emotion/styled'
import ContactMe from '../components/ContactMe'
import MainLayout from '../components/MainLayout'
import useRwd from '../utils/useRwd'
// image
import banner from '../assets/home/00首頁BN.png'
import aiProfesser from '../assets/home/01AI影像辨識專家.png'
import ai01 from '../assets/home/01AI影像辨識專家-1.png'
import ai02 from '../assets/home/01AI影像辨識專家-2.png'
import ai03 from '../assets/home/01AI影像辨識專家-3.png'
import ai04 from '../assets/home/01AI影像辨識專家-4.png'
import ai05 from '../assets/home/01AI影像辨識專家-5.png'
import ai06 from '../assets/home/01AI影像辨識專家-6.png'

import productions from '../assets/home/02產品陣容.png'
import pro01 from '../assets/home/02產品陣容-1.png'
import pro02 from '../assets/home/02產品陣容-2.png'
import pro03 from '../assets/home/02產品陣容-3.png'
import React from 'react'

export default function Home() {
  const { isPhone, isPC } = useRwd()
  const StyledImg = styled.img`
    width: 100%;
  `
  const cardContent = [
    {
      title: '慧智瞳：AI影像辨識專家',
      descript:
        '慧智瞳 AI 影像辨識技術，自動化處理影像數據，提升檢測效率與準確率！',
      defaultXs: isPhone ? 12 : 4,
      imgList: [
        <StyledImg src={ai01} alt="" />,
        <StyledImg src={ai02} alt="" />,
        <StyledImg src={ai03} alt="" />,
        <StyledImg src={ai04} alt="" />,
        <StyledImg src={ai05} alt="" />,
        <StyledImg src={ai06} alt="" />,
      ],
    },
    {
      title: '產品陣容',
      descript: '精準 AI 影像辨識，助力產業品質提升與安全管理',
      imgList: [
        <StyledImg src={pro01} alt="" />,
        <StyledImg src={pro02} alt="" />,
        <StyledImg src={pro03} alt="" />,
      ],
      defaultXs: isPhone ? 12 : 4,
    },
  ]
  return (
    <MainLayout bannerFile={banner} bannerAlt="首頁">
      <Grid
        container
        spacing={20}
        justifyContent="center"
        textAlign="center"
        alignItems="center"
      >
        {cardContent.map((item, i) => (
          <Grid item xs={12} key={i} style={{ justifyContent: 'center' }}>
            <HomeCard props={item} />
          </Grid>
        ))}
        <Grid item xs={12}>
          <ContactMe />
        </Grid>
      </Grid>
    </MainLayout>
  )
}

function HomeCard({ props }) {
  const { isPC } = useRwd()
  const { title, descript, imgList, defaultXs } = props
  return (
    <>
      <Typography variant="h3">{title}</Typography>
      <Typography variant="subtitle">{descript}</Typography>
      <Grid
        container
        justifyContent="center"
        textAlign="center"
        style={{ margin: '2em auto 0', width: isPC ? '70%' : '100%' }}
      >
        {imgList.map((item, i) => (
          <Grid item key={i} xs={defaultXs}>
            {item}
          </Grid>
        ))}
      </Grid>
    </>
  )
}
